import { Link, ProBadgeGradient, useToggle } from '@sparemin/blockhead';
import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThinWand } from 'components/icons';
import LinkButton from 'components/LinkButton';
import Popover from 'components/Popover';
import { onAiGenSocialCaptionsUpgradePoint } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';
import { hasSocialPostCaptionsAccessSelector } from 'redux/modules/pricing';
import { Dispatch } from 'redux/types';
import { useSocialShareModal } from '../SocialShareModalContext';
import { socialShareModalRegenerateTextButtonBlock as block } from '../utils';
import { REGENERATE_TEXT_OPTIONS } from './constants';
import { RegenerateTextValues } from './types';

export type SocialShareModalRegenerateTextButtonProps = {};

const SocialShareModalRegenerateTextButton: React.FC<SocialShareModalRegenerateTextButtonProps> = () => {
  const triggerElement = useRef<HTMLButtonElement>(null);

  const hasSocialPostCaptionsAccess = useSelector(
    hasSocialPostCaptionsAccessSelector,
  );
  const { regenerateSocialPostCaptions } = useSocialShareModal();

  const {
    value: isRegenerateTextPopoverOpen,
    toggleOn: openRegenerateTextPopover,
    toggleOff: closeRegenerateTextPopover,
  } = useToggle(false);

  const dispatch = useDispatch<Dispatch>();

  const handleUpgrade = useCallback(async () => {
    dispatch(onAiGenSocialCaptionsUpgradePoint());
    dispatch(replaceModal({ name: 'AICaptionsUpsell' }));
  }, [dispatch]);

  const handleRegenerateSocialPostCaptions = useCallback(
    (args: RegenerateTextValues) => {
      closeRegenerateTextPopover();
      regenerateSocialPostCaptions(args);
    },
    [closeRegenerateTextPopover, regenerateSocialPostCaptions],
  );

  return (
    <>
      {hasSocialPostCaptionsAccess ? (
        <Link
          as="button"
          ref={triggerElement}
          className={block('regenerate-text-button')}
          onClick={openRegenerateTextPopover}
        >
          <ThinWand width={12} height={12} fill="currentColor" />
          regenerate text
        </Link>
      ) : (
        <LinkButton
          theme="rainbow"
          onClick={handleUpgrade}
          className={block('locked-regenerate-text-button')}
        >
          regenerate text
          <ProBadgeGradient width={28} height={17} />
        </LinkButton>
      )}

      <Popover
        triggerElement={triggerElement?.current}
        isOpen={isRegenerateTextPopoverOpen}
        placement="bottom"
        offset={10}
        onClose={closeRegenerateTextPopover}
        variant="form"
      >
        <Popover.RadioGroup
          options={REGENERATE_TEXT_OPTIONS}
          ctaLabel="regenerate"
          defaultValue={{
            formality: 'neutral',
            tone: 'direct',
          }}
          onAction={handleRegenerateSocialPostCaptions}
        />
      </Popover>
    </>
  );
};

export default SocialShareModalRegenerateTextButton;
